// extracted by mini-css-extract-plugin
export var article = "d_j";
export var body = "d_g";
export var date = "d_k";
export var hero = "d_c";
export var title = "d_f";